module.exports = __webpack_public_path__ + "img/MAP.da7f1499.png";